<template>
    <div class="wp">
        <div class="w-1200 c-1">
            <p class="p1 pull-left">法律声明</p>
            <p class="p2 pull-left"> 本站的创新诊疗装备区域应用示范云平台由<span style="color:red;">重庆医科大学附属第二医院</span>运营和所有任何单位和个人不得在其他平台（包括但不限于网站、QQ和微信）上 转发和相互之间转发，任何转发、窃取、盗用、贩卖本站代理信息的行为都属于犯罪行为，窃取、盗用、贩卖本站代理信息50条以上将受到刑事处罚！</p>
        </div>
        <div class="w-1200 c-2">
            <div class="title-more">
                <div class="t-m-blue"></div>
                <p class="t-m-t">示范留言</p>
                <p class="t-m-t-2" style="width:200px;padding-left:10px;">共找到留言<span style="color:red;">{{totalNumber}}</span>条</p>
            </div>
            <div class="form-search-1">
                <el-form :inline="true" style="width:80%;float:left;" size="small" :model="formInline" >
                    <el-form-item >
                        <el-input v-model="titleName" placeholder="请输入标题搜索"></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-select v-model="region" placeholder="请选择区域">
                        <el-option v-for="(item,index) in provinces" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getData">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-button type="primary" icon="el-icon-edit-outline" @click="routerToUrl('/communicationPost')">我要发贴</el-button>
            </div>
            <div class="c-2-content">
                <div class="bread">
                    <el-breadcrumb separator="|">
                    <el-breadcrumb-item v-for="(item,index) in areaList" :key="index" >{{item.province_text}}<span style="padding-left:10px;color:#318BE6;">{{item.num}}</span></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <el-table
                    :data="jlzxList"
                    stripe
                    style="width: 100%"
                    @row-click="handleRowClick">
                    <el-table-column
                    prop="titleName"
                    label="标题">
                    </el-table-column>
                    <el-table-column
                    prop="area_text"
                    label="示范区域">
                    </el-table-column>
                    <el-table-column
                    prop="createUserName"
                    label="联系人">
                    </el-table-column>
                    <el-table-column
                    prop="sfType_text"
                    label="示范类型">
                    </el-table-column>
                    <el-table-column
                    prop="createDate"
                    label="发布时间">
                    </el-table-column>
                </el-table>
                <z-page :pageObj="page" @changePage1="changePage"></z-page>
            </div>
            
        </div>
    </div>
</template>
<script>
import Communication from './Communication.js';
export default Communication;
</script>
<style lang="scss" scoped>
@import './communication.scss';
</style>